module.exports = __webpack_public_path__ + "static/media/retirement-object-2-1-2.658baffe.png";